module.exports = __webpack_public_path__ + "img/icon-licence-color.0c8839f8.png";